import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDocument = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 11.25C8.08579 11.25 7.75 11.5858 7.75 12C7.75 12.4142 8.08579 12.75 8.5 12.75H15.5C15.9142 12.75 16.25 12.4142 16.25 12C16.25 11.5858 15.9142 11.25 15.5 11.25H8.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.75 8C7.75 7.58579 8.08579 7.25 8.5 7.25H12.5C12.9142 7.25 13.25 7.58579 13.25 8C13.25 8.41421 12.9142 8.75 12.5 8.75H8.5C8.08579 8.75 7.75 8.41421 7.75 8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 15.25C8.08579 15.25 7.75 15.5858 7.75 16C7.75 16.4142 8.08579 16.75 8.5 16.75H15.5C15.9142 16.75 16.25 16.4142 16.25 16C16.25 15.5858 15.9142 15.25 15.5 15.25H8.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7 2.25C4.92893 2.25 3.25 3.92893 3.25 6V18C3.25 20.0711 4.92893 21.75 7 21.75H17C19.0711 21.75 20.75 20.0711 20.75 18V6C20.75 3.92893 19.0711 2.25 17 2.25H7ZM4.75 6C4.75 4.75736 5.75736 3.75 7 3.75H17C18.2426 3.75 19.25 4.75736 19.25 6V18C19.25 19.2426 18.2426 20.25 17 20.25H7C5.75736 20.25 4.75 19.2426 4.75 18V6Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconDocument as ReactComponent };
